import { DIAGNOSTICS_CONSTANTS } from '@/config/url.config.ts'
import { hasPermission } from '@/features/permissions/hasPermission.ts'
import { DOMOPHONE_PERMISSIONS as P, type Permission } from '@/features/permissions/permissions.env.ts'

// Одни и те же права используются для меню и защиты прямых адресов.
export const diagnosticsPagePermissions: Record<string, Permission[]> = {
	[DIAGNOSTICS_CONSTANTS.overview()]: [P.GET_INTERCOM_SYSTEM_INFO],
	[DIAGNOSTICS_CONSTANTS.general()]: [P.GET_INTERCOM_SYSTEM_INFO],
	[DIAGNOSTICS_CONSTANTS.codes()]: [P.GET_INTERCOM_OPEN_CODES],
	[DIAGNOSTICS_CONSTANTS.doors()]: [P.GET_INTERCOM_RELAY_SETTINGS, P.GET_INTERCOM_DISPLAY_SETTINGS],
	[DIAGNOSTICS_CONSTANTS.marquee()]: [P.GET_INTERCOM_DISPLAY_SETTINGS],
	[DIAGNOSTICS_CONSTANTS.sip()]: [P.GET_INTERCOM_SIP_SETTINGS],
	[DIAGNOSTICS_CONSTANTS.video()]: [P.GET_INTERCOM_CAMERA_CODEC],
	[DIAGNOSTICS_CONSTANTS.firmware()]: [P.GET_INTERCOM_SYSTEM_UPGRADE],
	[DIAGNOSTICS_CONSTANTS.datetime()]: [P.GET_INTERCOM_SYSTEM_SETTINGS],
	[DIAGNOSTICS_CONSTANTS.reset()]: [P.FACTORY_RESET],
	[DIAGNOSTICS_CONSTANTS.network()]: [P.GET_INTERCOM_NETWORK],
	[DIAGNOSTICS_CONSTANTS.syslog()]: [P.GET_INTERCOM_SYSLOG]
}

export function getDiagnosticsEntryPath(permissions: Permission[]) {
	if (hasPermission(permissions, diagnosticsPagePermissions[DIAGNOSTICS_CONSTANTS.overview()])) {
		return DIAGNOSTICS_CONSTANTS.overview()
	}
	if (hasPermission(permissions, [P.GET_INTERCOM_PANEL_APARTMENTS])) return DIAGNOSTICS_CONSTANTS.apartments()
	if (
		hasPermission(permissions, [P.ADD_INTERCOM_KEY_STORE]) ||
		hasPermission(permissions, [P.GET_INTERCOM_KEY_STORE])
	) {
		return DIAGNOSTICS_CONSTANTS.keys()
	}
	return null
}
